var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6857 33.9455H21.2614C22.2391 33.9455 23.0566 33.7135 23.7455 33.3023C23.827 33.6705 24.1549 33.9452 24.5479 33.9452H34.4109C34.8654 33.9452 35.2328 33.5778 35.2328 33.1233C35.2328 32.6687 34.8654 32.3013 34.4109 32.3013H24.9228C26.679 30.2732 27.2764 26.689 27.8253 23.3965L27.8256 23.3948C28.7495 17.8515 29.5928 14.2184 32.7688 14.2184H37.7014C38.156 14.2184 38.5234 13.8502 38.5234 13.3965C38.5234 12.9428 38.156 12.5745 37.7014 12.5745H32.7688C27.9634 12.5745 27.0293 18.1781 26.205 23.1234L26.2047 23.1252C25.2808 28.6685 24.4375 32.3015 21.2614 32.3015H14.6857C14.232 32.3015 13.8638 32.669 13.8638 33.1235C13.8638 33.578 14.232 33.9455 14.6857 33.9455ZM36.2621 40.5215C36.0516 40.5215 35.8412 40.4409 35.6809 40.2806C35.3595 39.9592 35.3595 39.4398 35.6809 39.1184L41.6755 33.1238L35.6809 27.1293C35.3595 26.8079 35.3595 26.2884 35.6809 25.967C36.0023 25.6456 36.5218 25.6456 36.8432 25.967L44 33.1238L36.8432 40.2806C36.6829 40.4409 36.4725 40.5215 36.2621 40.5215Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6809 20.5538C35.8412 20.7141 36.0516 20.7947 36.2621 20.7947C36.4725 20.7947 36.6829 20.7149 36.8432 20.5546L44 13.397L36.8432 6.24104C36.5218 5.91965 36.0023 5.91965 35.6809 6.24104C35.3595 6.56243 35.3595 7.0819 35.6809 7.40329L41.6755 13.397L35.6809 19.3916C35.3595 19.713 35.3595 20.2324 35.6809 20.5538ZM4 38.8772H15.5074V27.3698H4V38.8772ZM13.8635 37.2333H5.64392V29.0137H13.8635V37.2333Z",
    fill: "#DC0032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInFlight);
export default __webpack_public_path__ + "static/media/iconInFlight.31b8277b7d740326631d4d046a6927e4.svg";
export { ForwardRef as ReactComponent };